export default {
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            parentNeedsRelativePosition: false
        }
    },

    watch: {
        isLoading() {
            this.updateParentPosition();
        }
    },

    mounted() {
        this.setParentNeedsRelativePosition();
        this.updateParentPosition();
    },

    beforeDestroy() {
        if (this.parentNeedsRelativePosition) {
            this.restoreParentPosition();
        }
    },

    methods: {
        setParentNeedsRelativePosition() {
            let parentPosition = $(this.$el).parent().css('position');

            if (parentPosition !== 'relative') {
                this.parentNeedsRelativePosition = true;
            }
        },

        updateParentPosition() {
            if (!this.parentNeedsRelativePosition) {
                return;
            }

            if (this.isLoading) {
                this.setParentPosition();
            } else {
                this.restoreParentPosition();
            }
        },

        setParentPosition() {
            $(this.$el).parent().css('position', 'relative');
        },

        restoreParentPosition() {
            $(this.$el).parent().css('position', '');
        }
    }
}